/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../Store';

const self = (state: RootState) => state.language;

export const getActiveLanguage = createSelector(self, (state) => state.activeLanguage);
export const getAvailableLanguages = createSelector(self, (state) => state.availableLanguagesList);
export const getIsRTL = createSelector(getActiveLanguage, (state) => ['ar'].includes(state));
